import styled from '@emotion/styled';
import DownIcon from '../../../../images/arrow/down.svg';

export const Label = styled.label`
display: inline-block;
width: calc((100% - 16px) / 2);
width: auto;
height:auto;
position: relative;
display: flex;
flex-direction:column;
gap: 8px;
font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 150%;
color: var(--colors-grey-500);
@media (max-width: 689px) {
width: 100%;
  
  } 
`;
export const HorizontalBox = styled.div`
display: flex;
align-items: center;

gap: 16px;
@media (max-width: 689px) {
  gap: 12px;
&.mobb{
  flex-direction: column;
}
  
  } 
`;

export const InputLabel1 = styled(Label)`
display: flex;
flex-direction:column;
gap: 8px;
align-items: flex-start;
font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 150%;
color: var(--colors-grey-500);
width: calc((100% - 16px) / 2);
@media (max-width: 689px) {
width: 100%;
  
  } 
`;
export const CustomInput = styled.input`
  text-align: center;
  width: 317px;
  height: 48px;
  border: 1px solid var(--colors-grey-100);
  border-radius: 360px;
  padding: 8px 16px;
  padding-right: 40px;
  font-family: var(--font-family);
  font-weight: 500;
  font-size: 16px;
  line-height: 137%;
  color: var(--colors-grey-900);
  outline: none;
  position: relative;
  &:focus{
  border: 1px solid var(--colors-grey-100);
}
  &::placeholder {
    color: var(--colors-grey-400);
    text-align: left;
  }
  &.open-calendar {
     border-radius: 16px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  }
`;

export const InputTime = styled.input`
-webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  &::-webkit-calendar-picker-indicator {
    display: none;
  }

  text-align: center;
  height:48px;
  border: 1px solid var(--colors-grey-100);
border-radius: 360px;
padding: 8px 16px;
width:125px;
  font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 137%;
color: var(--colors-grey-900);
outline:none;
  &::placeholder{
    color: var(--colors-grey-400);
  }
`;
